import React, { useState } from "react";
import { Link } from "react-router-dom";
import icons1 from "./SubIcons/icons1.svg";
import icons2 from "./SubIcons/icons2.svg";
import icons3 from "./SubIcons/icons3.svg";
import icons4 from "./SubIcons/icons4.svg";
import logoColourful from "../assets/logo/logo-colorful.svg";
import navCloseIcon from "../assets/navCloseIcon.svg";
import rightArrow from "../assets/right-arrow.svg";
import leftArrow from "../assets/arrow__left.svg";
import hamburger from "../assets/hamburger.svg";
import whiteLogo from "../assets/logo/logo_white.svg";
import HomeHamburger from "../assets/HomeHameburger.svg";

const rMenu = [
  {
    id: "1",
    name: "How it works",
    to: "/howitwork",
    submenu: [],
  },
  {
    id: "2",
    name: "Customers",
    to: "/",
    activ: true,
    submenu: [
      {
        leftItem: [
          {
            icon: icons1,
            title: "Individuals",
            to: "/individuals",
            para: "Learn about how individuals use wecanrush for their everyday pickups and deliveries",
          },
          {
            icon: icons2,
            iconTitle: "",
            title: "Businesses",
            to: "/business",
            para: "Learn about how businesses use wecanrush as their trusted logistics partner.",
          },
        ],
        leftTitle: "WECANRUSH FOR",
        rightTitle: "LOCATIONS",
        rightItem: [
          {
            to: "#",
            rItemss: "Indianapolis",
          },

          {
            to: "#",
            rItemss: "Fort Wayne",
          },

          {
            to: "#",
            rItemss: "Louisville",
          },

          {
            to: "#",
            rItemss: "Cincinnati",
          },
          {
            to: "#",
            rItemss: "Columbus",
          },
        ],
      },
    ],
  },
  {
    id: "3",
    name: "Drivers",
    to: "/drivers",
    submenu: [],
  },
  {
    id: "4",
    name: "Industries",
    to: "/industries",
    submenu: [],
  },
  {
    id: "5",
    name: "Resources",
    to: "/",
    activ: true,
    submenu: [
      {
        leftItem: [
          {
            icon: icons3,
            iconTitle: "",
            title: "Blog",
            to: "/blog",
            para: "Get started with tips and information about how wecanrush operates.",
          },
          {
            icon: icons4,
            title: "Help Desk",
            to: "https://wecanrush.zendesk.com/",
            para: "Need to talk to someone on our team about anything, Find us here.",
          },
        ],
        leftTitle: "RESOURCES",
        rightTitle: "OTHERS",
        rightItem: [
          {
            to: "/faq",
            rItemss: "FAQs",
          },

          {
            to: "/howitwork",
            rItemss: "Track your item",
          },

          {
            to: "/about",
            rItemss: "About",
          },

          {
            to: "/contactus",
            rItemss: "Contact",
          },
        ],
      },
    ],
  },
];
const MobileMenu = () => {
  const [navItem, newNaveItem] = useState("");

  function backSubMenuItem() {
    newNaveItem(
      <>
        <div class="m_deader_fixed">
          <ul className="m_header_ul">
            <div
              style={{ background: "#fff" }}
              className="m__header__container"
            >
              <Link to="/">
                <div className="m_logo">
                  <img src={logoColourful} alt="logo" />
                </div>
              </Link>
              <div onClick={() => newNaveItem("")} className="m_close">
                <img src={navCloseIcon} alt="hamburger" />
              </div>
            </div>
            {rMenu.map((items, id) => {
              return (
                <>
                  <li
                    key={id}
                    onClick={() => {
                      subMenuItem(items);
                    }}
                    className="m_header_list"
                  >
                    <Link to={items.to} className="m_header_list_item">
                      {items.name}
                      {items.submenu.map(() => (
                        <img
                          src="../../assets/right-arrow.svg"
                          alt="hamburger"
                        />
                      ))}
                    </Link>
                  </li>
                </>
              );
            })}
            <li>
              <div className="signup__mobile__btn">
                <Link
                  onClick={() =>
                    window.open("https://app.wecanrush.com/login", "_blank")
                  }
                >
                  <button className="header__first__btn">Login</button>
                </Link>
                <Link
                  onClick={() =>
                    window.open("https://app.wecanrush.com/register", "_blank")
                  }
                >
                  <button className="header__sececond__btn">
                    Create a free account
                  </button>
                </Link>
              </div>
            </li>
          </ul>
        </div>
      </>
    );
  }
  function subMenuItem(items) {
    if (items.activ) {
      newNaveItem(
        <div class="m_deader_fixed">
          <ul className="m_header_ul">
            <div
              style={{ background: "#fff" }}
              className="m__header__container"
            >
              <Link to="/">
                <div className="m_logo">
                  <img src={logoColourful} alt="logo" />
                </div>
              </Link>

              <div onClick={() => newNaveItem("")} className="m_close">
                <img src={navCloseIcon} alt="hamburger" />
              </div>
            </div>

            <li className="MenuItemBack">
              <Link
                onClick={backSubMenuItem}
                to={items.to}
                className="m_header_list_item"
              >
                <img src={leftArrow} alt="hamburger" />
                {items.name}
              </Link>

              {items.submenu.map((item, id) => (
                <div key={id} className="m_sub_header_wrapper">
                  <div className="m_sub_header_left_container">
                    <h3>
                      {() => <img src={rightArrow} alt="hamburger" />}
                      {item.leftTitle}
                    </h3>
                    {item.leftItem.map((lItem, ind) => (
                      <div key={ind} className="m_sub_header_left_content">
                        <div className="left_content_header">
                          <i className="icon">
                            <img src={lItem.icon} alt={lItem.iconTitle} />
                          </i>
                          <Link
                            onClick={() => window.open(`${lItem.to}`, "_blank")}
                          >
                            <h2>{lItem.title}</h2>
                          </Link>
                        </div>
                        <p>{lItem.para}</p>
                      </div>
                    ))}
                  </div>
                  <div className="m_sub_header_wright_container">
                    <h3>{item.rightTitle}</h3>
                    <ul className="m_sub_header_wright_ul">
                      {item.rightItem.map((rItem, ind) => (
                        <li key={ind}>
                          <Link
                            to={rItem.to}
                            key="{ind} to={items.to}"
                            className="m_header_list_item"
                          >
                            {rItem.rItemss}
                          </Link>
                        </li>
                      ))}
                      <li>
                        <div className="signup__mobile__btn">
                          <Link
                            onClick={() =>
                              window.open(
                                "https://app.wecanrush.com/login",
                                "_blank"
                              )
                            }
                          >
                            <button className="header__first__btn">
                              Login
                            </button>
                          </Link>
                          <Link
                            onClick={() =>
                              window.open(
                                "https://app.wecanrush.com/register",
                                "_blank"
                              )
                            }
                          >
                            <button className="header__sececond__btn">
                              Create a free account
                            </button>
                          </Link>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              ))}
            </li>
          </ul>
        </div>
      );
    } else {
      newNaveItem("");
    }
  }

  function menuBarIcon() {
    newNaveItem(
      <div class="m_deader_fixed">
        <ul className="m_header_ul">
          <div style={{ background: "#fff" }} className="m__header__container">
            <Link to="/">
              <div className="m_logo">
                <img src={logoColourful} alt="logo" />
              </div>
            </Link>
            <div onClick={() => newNaveItem("")} className="m_close">
              <img src={navCloseIcon} alt="hamburger" />
            </div>
          </div>

          {rMenu.map((items, id) => {
            return (
              <>
                <li
                  key={id}
                  onClick={() => {
                    subMenuItem(items);
                  }}
                  className="m_header_list"
                >
                  <Link to={items.to} className="m_header_list_item">
                    {items.name}
                    {items.submenu.map(() => (
                      <img src={rightArrow} alt="rightArrow" />
                    ))}
                  </Link>
                </li>
              </>
            );
          })}
          <li>
            <div className="signup__mobile__btn">
              <Link
                onClick={() =>
                  window.open("https://app.wecanrush.com/login", "_blank")
                }
              >
                <button className="header__first__btn">Login</button>
              </Link>
              <Link
                onClick={() =>
                  window.open("https://app.wecanrush.com/register", "_blank")
                }
              >
                <button className="header__sececond__btn">
                  Create a free account
                </button>
              </Link>
            </div>
          </li>
        </ul>
      </div>
    );
  }

  return (
    <>
      <div style={{ background: "#6300ff" }} className="m__header__container">
        <Link to="/">
          <div className="m_logo">
            <img src={whiteLogo} alt="logo" />
          </div>
        </Link>

        <div onClick={menuBarIcon} className="m_close">
          <img src={HomeHamburger} alt="hamburger" />
        </div>
      </div>

      {navItem}
    </>
  );
};

export default MobileMenu;
